import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { buildIndirectTaxFilingsV2ListQuery } from './helpers';
import {
  IIndirectTaxFilingV2ListResponse,
  IIndirectTaxFilingsV2ListParams,
  IUseIndirectTaxFilingsV2Options,
} from './types';

export function useIndirectTaxFilingsV2(
  params: IIndirectTaxFilingsV2ListParams | null,
  { keepPreviousData = true }: IUseIndirectTaxFilingsV2Options = {}
) {
  const key = params
    ? `new-sales-tax/filings-v2?${buildIndirectTaxFilingsV2ListQuery(params).toString()}`
    : null;

  const { data, error, isLoading, mutate } =
    useSWR<IIndirectTaxFilingV2ListResponse>(
      key,
      SWRFetcher({ method: 'GET' }),
      { keepPreviousData: params !== null && keepPreviousData }
    );

  return {
    filings: data?.filings ?? [],
    count: data?.count ?? 0,
    nextCursor: data?.nextCursor ?? null,
    isLoading,
    error,
    mutate,
  };
}
